"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.wrapValidator = exports.quotedNames = exports.alwaysValid = void 0;

var alwaysValid = function alwaysValid() {
  return null;
};

exports.alwaysValid = alwaysValid;

var quotedNames = function quotedNames(names) {
  return names.map(function (name) {
    return "\"".concat(name, "\"");
  }).join(', ');
};

exports.quotedNames = quotedNames;

var wrapValidator = function wrapValidator(validator) {
  return function () {
    if (process.env.NODE_ENV !== 'production') {
      return validator.apply(void 0, arguments);
    }

    return alwaysValid;
  };
};

exports.wrapValidator = wrapValidator;